import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect ,useState} from "react";
import axios from "axios";

const Btn = ({myReportStyle}) => {
       const [microbiomeUrl, setMicrobiomeUrl] = useState('');
       const [kit, setkit] = useState({
        "kitid": "loading...",
        "patientName": "loading...",
        "receiveddate": "loading...",
        "resultDate": "loading...",
        "result": [
            { "Helicobacter pylori": "loading..." },
            { "Plesiomonas shigelloides": "loading..." },
            { "Clostridium difficile": "loading..." },
            { "Enteroinvasive E. coli (EIEC)": "loading..." },
            { "Yersinia enterocolitica": "loading..." },
            { "Adenovirus": "loading..." },
            { "Salmonella": "loading..." },
            { "Astrovirus": "loading..." },
            { "Campylobacter jejuni/coli": "loading..." },
            { "Norovirus GI/GII": "loading..." },
            { "Vibrio cholerae": "loading..." },
            { "Rotavirus A": "loading..." },
            { "E. coli O157": "loading..." },
            { "Sapovirus (I,II,IV and V)": "loading..." },
            { "Enteroaggregative E. coli (EAEC)": "loading..." },
            { "Cryptosporidium spp": "loading..." },
            { "Enteropathogenic E. coli (EPEC)": "loading..." },
            { "Cyclospora cayetanensis": "loading..." },
            { "Enterotoxigenic E. coli (ETEC)": "loading..." },
            { "Entamoeba histolytica": "loading..." },
            { "Shigatoxin-producing E. coli (STEC)": "loading..." },
            { "Giardia lamblia": "loading..." }
        ],
    });
  const getdata = async () => {
    let data = JSON.stringify({
      _id: id,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then(async (response) => {
        await setkit(response.data);
        const microbiomePdfUrl = response.data.result.find(
          (item) => item["microbiomepdf"]
        )?.["microbiomepdf"];

        await setMicrobiomeUrl(microbiomePdfUrl);
        
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      await getdata();
     
    };
    fetchData();
  }, []);

// useEffect(() => {
//   console.log(myReportStyle)
// }, [myReportStyle])


  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div>
      <div className="flex justify-center">
        <img
          // src="/logo2.png"
          src={myReportStyle.logo}
          alt=""
          style={{ marginTop: "40px", width: "200px" }}
        />
      </div>
      <h1 style={{color:"#6e509c",fontSize:"30px",marginTop:"20px",marginBottom:"25px",fontWeight:"bold"}}>MicrobiomeAdvance</h1>
      <h2 style={{color:"#6e509c",fontSize:"18px"}}>    Name   : {kit.patientName}</h2>
      <h2 style={{color:"#6e509c",fontSize:"18px"}}>Kit ID : {kit.kitid}</h2>
      <div
        className=""
        style={{ display: "flex", justifyContent: "center", gap: "40px" }}
      >

        

        <button
  onClick={() => {
    
  

    if (microbiomeUrl) {

      const link = document.createElement("a");
      link.href = microbiomeUrl; // The URL of the PDF file
      // link.target = "_blank"; // Optional: Opens in a new tab
      link.download = "Microbiome_Test_Report.pdf"; // Suggests a filename for the downloaded file
      link.click();
    } else {
     window.location.href = "https://microbiome-report.yourgutmap.co.uk/"+id;
    }
  }}

  

  

  



  style={{
    marginTop: "30px",
    background: "#6e509c",
    color: "white",
    border: "none",
    padding: "10px 33px",
    borderRadius: "10px",
  }}
>
Microbiome Client Report
</button>
        <button
          onClick={() => navigate("/" + id + "/parasitology")}
          style={{
            marginTop: "30px",
            background: "#6e509c",
            color: "white",
            border: "none",
            padding: "10px 33px",
            borderRadius: "10px",
          }}
        >
          Parasitology Test Report
        </button>
        <button
          onClick={() => navigate("/" + id + "/candida")}
          style={{
            marginTop: "30px",
            background: "#6e509c",
            color: "white",
            border: "none",
            padding: "10px 33px",
            borderRadius: "10px",
          }}
        >
          Candida Test Report
        </button>
      </div>
      <h1 style={{color:"#6e509c",display:"flex",justifyContent:"center",fontSize:"19px",marginTop:"70px",marginBottom:"25px",fontWeight:"bold"}}>To view Practitioner Report, Recipes & Diet Planning, log into your microbiome portal here.</h1>
      <button
          // onClick={() => navigate("https://lab.yourgutmap.co.uk")}
          onClick={() => (window.location.href = "https://lab.yourgutmap.co.uk")}
          style={{
            marginTop: "0px",
            background: "#f28770",
            color: "white",
            border: "none",
            padding: "10px 83px",
            borderRadius: "10px",
          }}
        >
          Click to Login
        </button>
    </div>
  );
};

export default Btn;
